import React from "react";
import { Box, Chip } from "@mui/material";

export default function FilterBreadcrumbs({
  filters,
  labels,
  onRemove,
}) {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
      {Object.entries(filters).map(([key, value]) => {
        if (!value || (Array.isArray(value) && value.length === 0)) return null;

        const values = Array.isArray(value) ? value : [value];

        return values.map((item) => (
          <Chip
            key={`${key}-${item}`}
            label={`${labels[key] || key}: ${item}`}
            size="small"
             sx={{
    bgcolor: "#6b6f6445",
    color: "#334155",
    "& .MuiChip-deleteIcon": {
      color: "#334155",
    },
    "& .MuiChip-deleteIcon:hover": {
      color: "#334155",
    },
  }}
            // color="primary"
            variant="outlined"
            onDelete={() => onRemove(key, item)}
          />
        ));
      })}
    </Box>
  );
}

export const FILTER_LABELS = {
  // Common
  priority_value: "Priority",
  episode_identifier: "Episode",
  episode_id: "Episode",
  file_type: "File",
  file_name: "File",
  coder_name: "Coder",
  status: "Status",

  // Diagnosis / DRG
  principal_diagonsis: "Diagnosis", // Enhance Workflow
  principal_diagnosis: "Diagnosis", // Combined/Plus
  drg: "DRG",
  actual_drg: "Actual DRG",
  predicted_drg1: "Predicted DRG 1",
  predicted_drg2: "Predicted DRG 2",

  // Speciality / Health Fund
  case_mix_speciality: "Speciality",
  speciality: "Speciality",
  insurer_identifier: "Health Fund",
  health_fund: "Health Fund",
  health_fund_identifier: "Health Fund",

  // Audit
  audit_rule_category: "Audit Category",
  audit_ref_no: "Reference No",
  audit_rule_ref_no: "Reference No",
  audit_rule_reference_no: "Reference No",

  // Priority
  code_enhance_priority: "Code Enhance Priority",

  // Dates
  admission_date_from: "Admission From",
  admission_date_to: "Admission To",
  separation_date_from: "Separation From",
  separation_date_to: "Separation To",
  discharge_date_from: "Discharge From",
  discharge_date_to: "Discharge To",

  // LOS
  los_op: "LOS Operator",
  length_of_stay: "LOS",

  // Others
  sex: "Sex",
  age: "Age",
  medical_record_number: "MRN",
};